export const darkTheme = {
    bg:"#1C1C27",
    bgLight: "#1C1E27",
    primary:"#854CE6",
    text_primary:"#F2F3F4",
    text_secondary:"#b1b2b3",
    card:"#171721",
    card_light: '#191924',
    button:"#854CE6",
    white:"#FFFFFF",
    black:"#000000",
}

export const lightTheme = {
    bg: "#FFFFFF",
    bgLight: "#F6F4FB",
    primary: "#6D28D9",
    text_primary: "#16161D",
    text_secondary: "#5C5C6B",
    card: "#FFFFFF",
    card_light: "#FFFFFF",
    button: "#6D28D9",
    white: "#FFFFFF",
    black: "#16161D",
    content: "1440px",
}